var React = require('react');

function TwitterLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M303.61,784.6c364.33,0,563.55-301.83,563.55-563.55,0-8.58-.17-17.12-.56-25.6A403.16,403.16,0,0,0,965.41,92.89a395.49,395.49,0,0,1-113.74,31.18A198.82,198.82,0,0,0,938.76,14.5,397,397,0,0,1,813,62.58,197.86,197.86,0,0,0,668.41,0C559,0,470.31,88.7,470.31,198.06a197.06,197.06,0,0,0,5.15,45.16c-164.62-8.28-310.59-87.1-408.27-206.95A198.25,198.25,0,0,0,128.51,300.7,196.64,196.64,0,0,1,38.8,275.92c0,.82,0,1.66,0,2.53,0,95.93,68.28,176,158.9,194.18A197.93,197.93,0,0,1,108.21,476a198.29,198.29,0,0,0,185,137.57,397.44,397.44,0,0,1-246,84.78A405,405,0,0,1,0,695.64a560.78,560.78,0,0,0,303.61,89","fill":"#ffff"}));
}

TwitterLogo.defaultProps = {"viewBox":"0 0 965.41 784.6"};

module.exports = TwitterLogo;

TwitterLogo.default = TwitterLogo;
